import { Pipe, PipeTransform, Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { environment } from '../../environments/environment';


@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(
    private sanitizer: DomSanitizer
  ) {}

  transform( url: string ): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}


@Component({
    selector: "app-media-plan-selection",
    template: `
        <div class="embed-container">
            <iframe [src]="mediaPlanUrlProxy" 
                style="border: none; " height="100%" target="_parent">
            </iframe>
        </div>
    `,
    standalone: true,
    styleUrls: ["./media-plan-selection.component.scss"],
    imports: []
})

export class MediaPlanSelectionComponent implements OnInit, OnDestroy {
    isMobile: boolean = false;

    iframeData: string = "";

    mediaPlanUrl: string = "";
    mediaPlanUrlProxy: SafeResourceUrl = "";

    constructor(
        public responsive: BreakpointObserver,
        private sanitizer: DomSanitizer,
        private route: ActivatedRoute
    ) {
        //need to get this from config file and pump into the iframe
    }

    ngOnDestroy() {
        document.body.style.overflow = '';
    }

    async ngOnInit() {
        document.body.style.overflow = 'hidden';
        this.responsive.observe([
            Breakpoints.XSmall , Breakpoints.Small
              ])
              .subscribe(result => {
                this.isMobile = false; 
                if (result.matches) 
                  this.isMobile = true;      
          });

        this.route.queryParams.subscribe(params => {
            const promo = params['promo'];
            if(promo){
                if(promo.length > 0){
                    this.iframeData += "promo=" + promo
                }
            }

            const company = params['companyID'];
            if(company){
                
                if(company.length > 0){
                    if(this.iframeData.length > 0) this.iframeData += "&" 
                    this.iframeData += "companyID=" + company
                }
            }
        });

        this.mediaPlanUrlProxy = this.sanitizer.bypassSecurityTrustResourceUrl(
            environment.ConnectionInfo.MediaPageURL + "#" + this.iframeData
        );
    }
}